import request from '@/utils/request'
import config from '@/config'
export default {
  // 所有测站列表的获取
  getStationBaseList (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/station_base_list', { params })
  },
  // 保存面雨量信息
  postArealRainfallInfo (params) {
    return request.post(config.ApiYSQ + '/HydrologyCenter/save_areal_rainfall_info', params)
  },
  // 面雨量列表获取
  getArealRainfallList (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/areal_rainfall_list', { params })
  },
  // 面雨量配置保存接口
  postCollocationStationInfo (params) {
    return request.post(config.ApiYSQ + '/HydrologyCenter/save_collocation_station_info', params)
  },
  // 已配置面雨量或全区降雨量测站列表
  getConfiguredArealRainfallStation (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/configured_areal_rainfall_station', { params })
  },
  getlog (params) {
    return request.get(config.ApiYJ + '/log/get_log', { params })
  }
}
